<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #QuinielaAdmin
    v-layout(align-start='' justify-start='' row='' fill-height='')
      v-flex(xs12 md12 sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png' style='height: auto;width: 140px;')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Administración de Quiniela

    v-tabs(v-model='tab' background-color='black' dark style='margin-top:10px;')
      v-tab Configuración
      v-tab Tabla de Posiciones
      v-tab Apuestas

    v-tabs-items(v-model='tab')
      //- ── TAB CONFIG ─────────────────────────────────────────────
      v-tab-item
        v-layout(align-center='' justify-center='' row='' wrap='' style='margin-top:20px;')
          v-flex(xs12 sm8 md6)
            v-card.pa-4
              h3(style='margin-bottom:16px;') Configuración General
              v-text-field(outlined v-model='config.mundial' label='Nombre del Mundial' dense)
              v-checkbox(v-model='config.activo' label='Quiniela activa' color='#ff6500')
              v-divider(style='margin:12px 0;')
              h4(style='margin-bottom:12px;') Puntos por acierto
              v-layout(row wrap)
                v-flex(xs12 sm6 style='padding-right:8px;')
                  v-text-field(outlined v-model.number='config.pts_resultado_exacto' label='Resultado exacto' type='number' dense)
                v-flex(xs12 sm6)
                  v-text-field(outlined v-model.number='config.pts_diferencia_correcta' label='Diferencia correcta' type='number' dense)
                v-flex(xs12 sm6 style='padding-right:8px;')
                  v-text-field(outlined v-model.number='config.pts_ganador_correcto' label='Solo ganador' type='number' dense)
                v-flex(xs12 sm6)
                  v-text-field(outlined v-model.number='config.pts_bonus_eliminatoria' label='Bonus eliminatoria' type='number' dense)
              v-divider(style='margin:12px 0;')
              v-layout(row wrap)
                v-flex(xs12 sm6 style='padding-right:8px;')
                  v-text-field(outlined v-model='config.fecha_inicio' label='Fecha inicio' type='datetime-local' dense)
                v-flex(xs12 sm6)
                  v-text-field(outlined v-model='config.fecha_fin' label='Fecha fin' type='datetime-local' dense)
              v-layout(justify-center='')
                v-btn(style='background:#ff6500;margin-top:10px;' dark @click='guardarConfig' :loading='guardandoConfig') Guardar Configuración

      //- ── TAB TABLA ──────────────────────────────────────────────
      v-tab-item
        v-layout(align-center='' justify-end='' row='' wrap='' style='margin:10px 5px;')
          v-btn(style='background:#ff6500;border-radius:10px;' dark @click='cargarTabla') Actualizar
        v-layout(align-start='' justify-start='' row='' wrap='')
          v-flex(xs12)
            v-data-table.elevation-1(:headers='headersTabla' :items='tabla' :loading='loadingTabla')
              template(v-slot:items='props')
                td
                  v-chip(color='#ff6500' dark small) {{ props.index + 1 }}
                td {{ props.item.cliente }}
                td
                  strong(style='font-size:18px;color:#ff6500;') {{ props.item.puntos || 0 }}
                td {{ props.item.apuestas }}
                td {{ props.item.tickets_usados }}

      //- ── TAB APUESTAS ───────────────────────────────────────────
      v-tab-item
        v-layout(align-center='' justify-space-between='' row='' wrap='' style='margin:10px 5px;')
          v-flex(xs12 sm4)
            v-select(outlined v-model='filtroPartido' :items='partidosOpts' item-text='label' item-value='_id' label='Filtrar por partido' dense clearable)
          v-flex(xs12 sm2)
            v-btn(style='background:#ff6500;border-radius:10px;' dark @click='cargarApuestas') Buscar
        v-layout(align-start='' justify-start='' row='' wrap='')
          v-flex(xs12)
            v-data-table.elevation-1(:headers='headersApuestas' :items='apuestas' :loading='loadingApuestas')
              template(v-slot:items='props')
                td {{ props.item.cliente }}
                td {{ props.item.partido_id ? (props.item.partido_id.nombre_local + ' vs ' + props.item.partido_id.nombre_visitante) : '—' }}
                td {{ props.item.pronostico.goles_local }} - {{ props.item.pronostico.goles_visitante }}
                td {{ props.item.tickets.length }}
                td
                  span(v-if='props.item.puntos_total !== null')
                    strong(style='color:#ff6500;') {{ props.item.puntos_total }} pts
                  span(v-else) Pendiente
                td {{ props.item.fecha_apuesta ? $moment(props.item.fecha_apuesta).format('DD/MM/YYYY HH:mm') : '—' }}

  v-dialog(v-model='dialog4' persistent max-width='400px')
    v-container(style='max-width:400px;background:#f1f2f1;')
      div(style='margin-top:20px;')
        v-layout(align-start='' justify-center='' row='' wrap='')
          v-flex(xs12)
            v-card-title.justify-center
              h4.black--text Esperando Respuesta del Servidor...
          v-flex(xs12)
            div(style='display:flex;justify-content:center;')
              img(src='../assets/waiting.gif' height='150')
</template>

<script>
import Api from '@/services/methods'
export default {
  name: 'QuinielaAdmin',
  data: () => ({
    tab: 0,
    dialog4: false,
    config: {
      mundial: 'Mundial 2026',
      activo: false,
      pts_resultado_exacto: 3,
      pts_diferencia_correcta: 2,
      pts_ganador_correcto: 1,
      pts_bonus_eliminatoria: 1,
      fecha_inicio: '',
      fecha_fin: ''
    },
    guardandoConfig: false,
    tabla: [],
    loadingTabla: false,
    apuestas: [],
    loadingApuestas: false,
    partidos: [],
    filtroPartido: null,
    headersTabla: [
      { text: '#', sortable: false },
      { text: 'Cliente', value: 'cliente' },
      { text: 'Puntos', value: 'puntos' },
      { text: 'Apuestas', value: 'apuestas' },
      { text: 'Tickets usados', value: 'tickets_usados' }
    ],
    headersApuestas: [
      { text: 'Cliente', value: 'cliente' },
      { text: 'Partido', sortable: false },
      { text: 'Pronóstico', sortable: false },
      { text: 'Tickets', sortable: false },
      { text: 'Puntos', value: 'puntos_total' },
      { text: 'Fecha', value: 'fecha_apuesta' }
    ]
  }),
  computed: {
    partidosOpts () {
      return this.partidos.map(p => ({
        _id: p._id,
        label: p.nombre_local + ' vs ' + p.nombre_visitante + ' (' + this.$moment(p.fecha).format('DD/MM/YY') + ')'
      }))
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      Api.get('quiniela/config').then(res => {
        if (res.data) {
          this.config = Object.assign({}, res.data)
          if (this.config.fecha_inicio) this.config.fecha_inicio = this.$moment(this.config.fecha_inicio).format('YYYY-MM-DDTHH:mm')
          if (this.config.fecha_fin) this.config.fecha_fin = this.$moment(this.config.fecha_fin).format('YYYY-MM-DDTHH:mm')
        }
      })
      Api.get('quiniela/partidos').then(res => { this.partidos = res.data })
      this.cargarTabla()
    },
    guardarConfig () {
      this.guardandoConfig = true
      Api.post('quiniela/config', this.config).then(() => {
        this.guardandoConfig = false
        this.$swal.fire('Listo', 'Configuración guardada.', 'success')
      }).catch(() => {
        this.guardandoConfig = false
        this.$swal.fire('Error', 'No se pudo guardar la configuración.', 'error')
      })
    },
    cargarTabla () {
      this.loadingTabla = true
      Api.get('quiniela/tabla').then(res => {
        this.tabla = res.data
        this.loadingTabla = false
      }).catch(() => { this.loadingTabla = false })
    },
    cargarApuestas () {
      this.loadingApuestas = true
      const url = this.filtroPartido
        ? `quiniela/apuestas/partido/${this.filtroPartido}`
        : 'quiniela/apuestas'
      Api.get(url).then(res => {
        this.apuestas = res.data
        this.loadingApuestas = false
      }).catch(() => { this.loadingApuestas = false })
    }
  }
}
</script>
